// extracted by mini-css-extract-plugin
module.exports = {"container":"EABDContentCardIcon_container__27g0L","icon":"EABDContentCardIcon_icon__1pfLf"};